import React, { useContext, useEffect, useState } from 'react'
import { BrowserRouter, Switch, useHistory, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import LoggedInLayout from '../layout'
import Dashboard from '../pages/Dashboard/'
import TicketResponsiveContainer from '../pages/TicketResponsiveContainer'
import Signup from '../pages/Signup/'
import Login from '../pages/Login/'
import Connections from '../pages/Connections/'
import SettingsCustom from '../pages/SettingsCustom/'
import Financeiro from '../pages/Financeiro/'
import Users from '../pages/Users'
import Contacts from '../pages/Contacts/'
import ContactFiles from '../pages/ContactFiles/'
import Queues from '../pages/Queues/'
import Tags from '../pages/Tags/'
import Tasks from '../pages/Tasks/'
import Reminders from '../pages/Reminders/'
import MessagesAPI from '../pages/MessagesAPI/'
import Helps from '../pages/Helps/'
import ContactLists from '../pages/ContactLists/'
import ContactListItems from '../pages/ContactListItems/'
// import Companies from "../pages/Companies/";
import QuickMessages from '../pages/QuickMessages/'
import { AuthProvider } from '../context/Auth/AuthContext'
import { TicketsContextProvider } from '../context/Tickets/TicketsContext'
import { WhatsAppsProvider } from '../context/WhatsApp/WhatsAppsContext'
import Route from './Route'
import Schedules from '../pages/Schedules'
import Campaigns from '../pages/Campaigns'
import CampaignsConfig from '../pages/CampaignsConfig'
import CampaignReport from '../pages/CampaignReport'
import Annoucements from '../pages/Annoucements'
import Chat from '../pages/Chat'
import ToDoList from '../pages/ToDoList/'
import Subscription from '../pages/Subscription/'
import Relatorios from '../pages/Relatorios'
import BlackList from '../pages/BlackList'
import Wizard from '../pages/Wizard'
import Departments from '../pages/Departments'
import DepartmentsFlow from '../pages/DepartmentsFlow';
import PainelGestor from "../pages/PainelGestor";
import ClosingReasons from '../pages/ClosingReasons';
import Clientes from '../pages/Clientes';
import NotificationSounds from '../pages/NotificationSounds'
import ProtectedRoute from '../components/ProtectedRoute'
import useSettings from '../hooks/useSettings'
import { SocketContext } from '../context/Socket/SocketContext'
import { defaultExperimentalMenuItemKeys } from '../layout/experimentalMenuItems'

const experimentalRouteFeatures = [
  ['dashboard', '/'],
  ['tickets', '/tickets'],
  ['quickMessages', '/quick-messages'],
  ['schedules', '/schedules'],
  ['tags', '/tags'],
  ['tasks', '/tasks'],
  ['reminders', '/reminders'],
  ['notificationSounds', '/notification-sounds'],
  ['contacts', '/contacts'],
  ['clients', '/clientes'],
  ['contactFiles', '/contact-files'],
  ['campaigns', '/campaigns'],
  ['contactLists', '/contact-lists'],
  ['financeiro', '/financeiro'],
  ['announcements', '/announcements'],
  ['users', '/users'],
  ['reports', '/Relatorios'],
  ['managerPanel', '/painel-gestor'],
  ['connections', '/connections'],
  ['departments', '/departments'],
  ['wizard', '/Wizard']
]

const ExperimentalRouteGuard = () => {
  const history = useHistory()
  const location = useLocation()
  const socketManager = useContext(SocketContext)
  const { getPublicSetting } = useSettings()
  const [enableExperimental, setEnableExperimental] = useState(false)
  const [experimentalSettingsLoaded, setExperimentalSettingsLoaded] = useState(false)
  const [experimentalMenuItems, setExperimentalMenuItems] = useState(
    defaultExperimentalMenuItemKeys
  )

  useEffect(() => {
    let mounted = true

    const loadExperimentalSettings = async () => {
      try {
        const [enabledValue, menuItemsValue] = await Promise.all([
          getPublicSetting('enableExperimental'),
          getPublicSetting('experimentalMenuItems')
        ])

        if (!mounted) return

        setEnableExperimental(
          enabledValue === 'enabled' || enabledValue === 'true'
        )

        if (menuItemsValue) {
          try {
            const menuItems = JSON.parse(menuItemsValue)
            if (Array.isArray(menuItems)) {
              setExperimentalMenuItems(menuItems)
            }
          } catch {
            setExperimentalMenuItems(defaultExperimentalMenuItemKeys)
          }
        }

        setExperimentalSettingsLoaded(true)
      } catch {
        if (mounted) {
          setEnableExperimental(false)
          setExperimentalSettingsLoaded(true)
        }
      }
    }

    loadExperimentalSettings()

    return () => {
      mounted = false
    }
  }, [getPublicSetting])

  useEffect(() => {
    const socket = socketManager.GetSocket()

    const onExperimentalSettings = data => {
      if (data?.key === 'enableExperimental') {
        setEnableExperimental(data.value === 'enabled' || data.value === 'true')
        setExperimentalSettingsLoaded(true)
        return
      }

      if (data?.key === 'experimentalMenuItems') {
        try {
          const menuItems = JSON.parse(data.value)
          if (Array.isArray(menuItems)) {
            setExperimentalMenuItems(menuItems)
          }
        } catch {
          setExperimentalMenuItems(defaultExperimentalMenuItemKeys)
        }
      }
    }

    socket.on('experimentalSettings', onExperimentalSettings)

    return () => {
      socket.off('experimentalSettings', onExperimentalSettings)
    }
  }, [socketManager])

  useEffect(() => {
    const feature = experimentalRouteFeatures.find(([, path]) =>
      path === '/'
        ? location.pathname === path
        : location.pathname.startsWith(path)
    )?.[0]

    if (
      experimentalSettingsLoaded &&
      !enableExperimental &&
      feature &&
      experimentalMenuItems.includes(feature)
    ) {
      history.replace('/chats')
    }
  }, [
    enableExperimental,
    experimentalMenuItems,
    experimentalSettingsLoaded,
    history,
    location.pathname
  ])

  return null
}

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false)

  useEffect(() => {
    const cshow = localStorage.getItem('cshow')
    if (cshow !== undefined) {
      setShowCampaigns(true)
    }
  }, [])

  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            {/* <Route exact path="/create-company" component={Companies} /> */}
            <Route
              path="/"
              isPrivate
              component={() => (
                <WhatsAppsProvider>
                  <LoggedInLayout>
                    <ExperimentalRouteGuard />
                    <Route
                      exact
                      path="/"
                      isPrivate
                      component={() => (
                        <ProtectedRoute
                          requiredRoles={['super', 'admin']}
                          fallbackPath="/tickets"
                        >
                          <Dashboard />
                        </ProtectedRoute>
                      )}
                    />
                    <Route
                      exact
                      path="/tickets/:ticketId?"
                      component={TicketResponsiveContainer}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/connections"
                      component={Connections}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/quick-messages"
                      component={QuickMessages}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/schedules"
                      component={Schedules}
                      isPrivate
                    />
                    <Route exact path="/todolist" component={ToDoList} isPrivate />
                    <Route
                      exact
                      path="/Relatorios"
                      component={Relatorios}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/BlackList"
                      component={BlackList}
                      isPrivate
                    />
                    <Route exact path="/Wizard" component={Wizard} isPrivate />
                    <Route exact path="/tags" component={Tags} isPrivate />
                    <Route exact path="/tasks" component={Tasks} isPrivate />
                    <Route exact path="/reminders" component={Reminders} isPrivate />
                    <Route exact path="/contacts" component={Contacts} isPrivate />
                    <Route exact path="/contact-files" component={ContactFiles} isPrivate />
                    <Route exact path="/clientes" component={Clientes} isPrivate />
                    <Route
                      exact
                      path="/notification-sounds"
                      component={() => (
                        <ProtectedRoute
                          requiredRoles={['super']}
                          fallbackPath="/tickets"
                        >
                          <NotificationSounds />
                        </ProtectedRoute>
                      )}
                      isPrivate
                    />
                    <Route exact path="/helps" component={Helps} isPrivate />
                    <Route exact path="/users" component={Users} isPrivate />
                    <Route
                      exact
                      path="/messages-api"
                      component={MessagesAPI}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/settings"
                      component={SettingsCustom}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/financeiro"
                      component={Financeiro}
                      isPrivate
                    />
                    <Route exact path="/queues" component={Queues} isPrivate />
                    <Route exact path="/painel-gestor" component={PainelGestor} isPrivate />
                    <Route
                      exact
                      path="/closing-reasons"
                      component={ClosingReasons}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/departments"
                      component={Departments}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/announcements"
                      component={Annoucements}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/subscription"
                      component={Subscription}
                      isPrivate
                    />

                    <Route exact path="/chats/:id?" component={Chat} isPrivate />
                    {showCampaigns && (
                      <>
                        <Route
                          exact
                          path="/contact-lists"
                          component={ContactLists}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/contact-lists/:contactListId/contacts"
                          component={ContactListItems}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/campaigns"
                          component={Campaigns}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/campaign/:campaignId/report"
                          component={CampaignReport}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/campaigns-config"
                          component={CampaignsConfig}
                          isPrivate
                        />
                      </>
                    )}
                    <Route
                      exact
                      path="/departments-flow/:queueId"
                      component={DepartmentsFlow}
                      isPrivate
                    />
                  </LoggedInLayout>
                </WhatsAppsProvider>
              )}
            />
          </Switch>
          <ToastContainer autoClose={3000} />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default Routes